import label from "@/lang/StaticLabels.js";

export default {
  visitors: (state) => {
    return state.visitors;
  },

  branches: (state) => {
    return state.branches;
  },

  branch: (state) => {
    return state.branch;
  },

  branchCode: (state) => {
    return state.branchCode;
  },

  fiscalYears: (state) => {
    return state.fiscalYears;
  },
  fiscalYear: (state) => {
    return state.fiscalYear;
  },

  users: (state) => {
    return state.users;
  },
  user: (state) => {
    return state.user;
  },
  userId: (state) => {
    return state.userId;
  },

  usersGroup: (state) => {
    return state.usersGroup;
  },
  userGroup: (state) => {
    return state.userGroup;
  },

  roles: (state) => {
    return state.roles;
  },
  rolePermission: (state) => {
    return state.rolePermission;
  },
  userRolePermission: (state) => {
    return state.userRolePermission;
  },

  branchYears: (state) => {
    return state.branchYears;
  },

  countries: (state) => {
    return state.countries;
  },
  countryMaxCode: (state) => {
    return state.countryMaxCode;
  },

  provinces: (state) => {
    return state.provinces;
  },
  provinceMaxCode: (state) => {
    return state.provinceMaxCode;
  },

  cities: (state) => {
    return state.cities;
  },
  cityMaxCode: (state) => {
    return state.cityMaxCode;
  },

  region: (state) => {
    return state.region;
  },
  regionMaxCode: (state) => {
    return state.regionMaxCode;
  },

  personGroups: (state) => {
    return state.personGroups;
  },
  personGroupCode: (state) => {
    return state.personGroupCode;
  },

  persons: (state) => {
    return state.persons;
  },
  person: (state) => {
    return state.person;
  },
  personBySearch: (state) => {
    return state.personBySearch;
  },
  personNavigation: (state) => {
    return state.personNavigation;
  },
  personIsLegal: (state) => {
    return state.personIsLegal;
  },
  personEmployeeGroup: (state) => {
    return state.personEmployeeGroup;
  },
  isPersonGenralGroup: (state) => {
    return state.isPersonGenralGroup;
  },

  personId: (state) => {
    return state.personId;
  },

  personPosition: (state) => {
    return state.personPosition;
  },

  personFinancialInfo: (state) => {
    return state.personFinancialInfo;
  },
  personFinancialInfoCode: (state) => {
    return state.personFinancialInfoCode;
  },

  personTaxFiles: (state) => {
    return state.personTaxFiles;
  },
  personTaxFile: (state) => {
    return state.personTaxFile;
  },
  personTaxFilesCode: (state) => {
    return state.personTaxFilesCode;
  },

  personCode: (state) => {
    return state.personCode;
  },

  prefix: (state) => {
    return state.prefix;
  },
  prefixCode: (state) => {
    return state.prefixCode;
  },

  personContact: (state) => {
    return state.personContact;
  },

  sbuTree: (state) => {
    return state.sbuTree;
  },

  sbuList: (state) => {
    return state.sbuList;
  },

  floatAccountConfig: (state) => {
    return state.floatAccountConfig;
  },
  floatAccountGroup: (state) => {
    return state.floatAccountGroup;
  },

  floatGroupCodeOne: (state) => {
    return state.floatGroupCodeOne;
  },
  floatGroupCodeTwo: (state) => {
    return state.floatGroupCodeTwo;
  },
  floatGroupCodeThree: (state) => {
    return state.floatGroupCodeThree;
  },
  floatGroupCodeFour: (state) => {
    return state.floatGroupCodeFour;
  },
  floatGroupCodeFive: (state) => {
    return state.floatGroupCodeFive;
  },

  floatAccountOne: (state) => {
    return state.floatAccountOne;
  },
  floatAccountTwo: (state) => {
    return state.floatAccountTwo;
  },
  floatAccountThree: (state) => {
    return state.floatAccountThree;
  },
  floatAccountFour: (state) => {
    return state.floatAccountFour;
  },
  floatAccountFive: (state) => {
    return state.floatAccountFive;
  },

  floatAccountCode: (state) => {
    return state.floatAccountCode;
  },
  floatAccountCodeTwo: (state) => {
    return state.floatAccountCodeTwo;
  },
  floatAccountCodeThree: (state) => {
    return state.floatAccountCodeThree;
  },
  floatAccountCodeFour: (state) => {
    return state.floatAccountCodeFour;
  },
  floatAccountCodeFive: (state) => {
    return state.floatAccountCodeFive;
  },

  companyBoard: (state) => {
    return state.companyBoard;
  },
  companyBoardCode: (state) => {
    return state.companyBoardCode;
  },

  userLimitPersons: (state) => {
    return state.userLimitPersons;
  },
  userLimitFloatAccountsOne: (state) => {
    return state.userLimitFloatAccountsOne;
  },
  userLimitFloatAccountsTwo: (state) => {
    return state.userLimitFloatAccountsTwo;
  },
  userLimitFloatAccountsThree: (state) => {
    return state.userLimitFloatAccountsThree;
  },
  userLimitFloatAccountsFour: (state) => {
    return state.userLimitFloatAccountsFour;
  },
  userLimitFloatAccountsFive: (state) => {
    return state.userLimitFloatAccountsFive;
  },

  positionInfo: (state) => {
    return state.positionInfo;
  },
  positionCode: (state) => {
    return state.positionCode;
  },

  cartableConfirmPriority: (state) => {
    return state.cartableConfirmPriority;
  },

  signatureDetail: (state) => {
    return state.signatureDetail;
  },

  imageBrnach: (state) => {
    return state.imageBrnach;
  },

  personByMobile: (state) => {
    return state.personByMobile;
  },

  transactionInfo: (state) => {
    return state.transactionInfo;
  },

  currencyTypes: (state) => {
    return state.currencyTypes;
  },

  currencyTypeCode: (state) => {
    return state.currencyTypeCode;
  },

  currencyRates: (state) => {
    return state.currencyRates;
  },

  vehicleType: (state) => {
    return state.vehicleType;
  },

  suppliers: (state) => {
    return state.suppliers;
  },
  supplier: (state) => {
    return state.supplier;
  },
  supplierByPerson: (state) => {
    return state.supplierByPerson;
  },

  buyers: (state) => {
    return state.buyers;
  },
  buyer: (state) => {
    return state.buyer;
  },
  buyerByPerson: (state) => {
    return state.buyerByPerson;
  },

  smsSetting: (state) => {
    return state.smsSetting;
  },

  settings: (state) => {
    return state.settings;
  },

  contractors: (state) => {
    return state.contractors;
  },

  branchesAndOffices: (state) => {
    return state.branchesAndOffices;
  },
  branchesAndOfficesById: (state) => {
    return state.branchesAndOfficesById;
  },
  branchesAndOfficesCode: (state) => {
    return state.branchesAndOfficesCode;
  },

  saleAddMinus: (state) => {
    return state.saleAddMinus;
  },
  saleAddMinusById: (state) => {
    return state.saleAddMinusById;
  },
  saleAddMinusMaxCode: (state) => {
    return state.saleAddMinusMaxCode;
  },
  saleAddMinusPriority: (state) => {
    return state.saleAddMinusPriority;
  },

  buyAddMinuses: (state) => {
    return state.buyAddMinuses;
  },
  buyAddMinus: (state) => {
    return state.buyAddMinus;
  },
  buyAddMinusCode: (state) => {
    return state.buyAddMinusCode;
  },
  buyAddMinusPriority: (state) => {
    return state.buyAddMinusPriority;
  },
  buyAddMinusNavigation: (state) => {
    return state.buyAddMinusNavigation;
  },
  buyAddMinusSearch: (state) => {
    return state.buyAddMinusSearch;
  },

  banks: (state) => {
    return state.banks;
  },
  bankMaxCode: (state) => {
    return state.bankMaxCode;
  },

  bankBranches: (state) => {
    return state.bankBranches;
  },
  bankBranchMaxCode: (state) => {
    return state.bankBranchMaxCode;
  },
  bankBranchCode: (state) => {
    return state.bankBranchCode;
  },

  documentTypes: (state) => {
    return state.documentTypes;
  },
  documentTypesById: (state) => {
    return state.documentTypesById;
  },
  documentTypesMaxCode: (state) => {
    return state.documentTypesMaxCode;
  },

  companies: (state) => {
    return state.companies;
  },
  company: (state) => {
    return state.company;
  },

  userBranches: (state) => {
    return state.userBranches;
  },

  insuranceType: (state) => {
    return state.insuranceType;
  },
  insuranceTypeById: (state) => {
    return state.insuranceTypeById;
  },
  insuranceTypeCode: (state) => {
    return state.insuranceTypeCode;
  },

  employmentType: (state) => {
    return state.employmentType;
  },

  employmentTypeById: (state) => {
    return state.employmentTypeById;
  },

  employmentTypeCode: (state) => {
    return state.employmentTypeCode;
  },

  studyFieldType: (state) => {
    return state.studyFieldType;
  },

  studyFieldTypeById: (state) => {
    return state.studyFieldTypeById;
  },

  studyFieldTypeCode: (state) => {
    return state.studyFieldTypeCode;
  },

  degree: (state) => {
    return state.degree;
  },
  degreeById: (state) => {
    return state.degreeById;
  },
  degreeCode: (state) => {
    return state.degreeCode;
  },

  departments: (state) => {
    return state.departments;
  },
  departmentById: (state) => {
    return state.departmentById;
  },
  departmentCode: (state) => {
    return state.departmentCode;
  },

  personnels: (state) => {
    return state.personnels;
  },
  personnelById: (state) => {
    return state.personnelById;
  },
  personnelBySearch: (state) => {
    return state.personnelBySearch;
  },
  personnelCode: (state) => {
    return state.personnelCode;
  },
  personnelId: (state) => {
    return state.personnelId;
  },
  personnelNavigation: (state) => {
    return state.personnelNavigation;
  },

  serviceCenters: (state) => {
    return state.serviceCenters;
  },
  serviceCenterById: (state) => {
    return state.serviceCenterById;
  },
  serviceCenterCode: (state) => {
    return state.serviceCenterCode;
  },

  unitCount: (state) => {
    return state.unitCount;
  },
  unitCountCode: (state) => {
    return state.unitCountCode;
  },

  voucherTemplate: (state) => {
    return state.voucherTemplate;
  },

  // Static Getters ---------------------------------------------------------------
  fieldsPlanOptions() {
    return [
      { value: "A", text: "Plan A" },
      { value: "B", text: "Plan B" },
      { value: "C", text: "Plan C" },
      { value: "D", text: "Plan D" },
    ];
  },
  personnelGroupEditMenu() {
    return [
      {
        subItems: [
          {
            value: 1,
            title: label.caption.studyInfo,
          },
        ],
      },
      {
        subItems: [{ value: 2, title: label.caption.employmentInfo }],
      },
      {
        subItems: [{ value: 3, title: label.caption.taxInsuranceInfo }],
      },
    ];
  },

  // دستگاه‌های پوز ------------------------------------------------------------
  posTerminals: (state) => {
    return state.posTerminals;
  },
  posTerminalTypeOptions: (state) => {
    return state.posTerminalTypes.map((item) => ({
      value: item.id ?? item.value,
      text: item.title ?? item.text,
    }));
  },
  connectionTypeOptions: (state) => {
    return state.connectionTypes.map((item) => ({
      value: item.id ?? item.value,
      text: item.title ?? item.text,
    }));
  },

  // بن کارت -------------------------------------------------------------------
  benefitCards: (state) => {
    return state.benefitCards;
  },
  benefitCardTypeOptions: (state) => {
    return state.benefitCardTypes.map((item) => ({
      value: item.id ?? item.value,
      text: item.title ?? item.text,
    }));
  },
  benefitCardTransactions: (state) => {
    return state.benefitCardTransactions;
  },
  benefitCardTransactionTypeOptions: (state) => {
    return state.benefitCardTransactionTypes.map((item) => ({
      value: item.id ?? item.value,
      text: item.title ?? item.text,
    }));
  },
};
